import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import s from './DeviationAttributeCSV.scss';
/** Comma separated locale string values describing certain classifications of deviations
 *  including: mature-level, generated by ai, etc. to be rendered in the details section */ const DeviationAttributeCSV = ({ deviation , className  })=>{
    const { t  } = useTranslation();
    // TODO: remove any when clearing ai_generated
    const { isMature , isNsfg , isAiGenerated  } = deviation;
    const ai_generated = useFlag('ai_generated');
    const values = [];
    if (ai_generated && isAiGenerated) {
        values.push(t('deviation.details.aiGenerated'));
    }
    if (isMature) {
        values.push(isNsfg ? t('deviation.details.nsfg') : t('deviation.details.mature'));
    }
    return !values.length ? null : /*#__PURE__*/ React.createElement("div", {
        className: classnames(className, s['root'])
    }, /*#__PURE__*/ React.createElement("span", null, values.join(', ')));
};
DeviationAttributeCSV.displayName = 'DeviationAttributeCSV';
export default DeviationAttributeCSV;
